export default __webpack_public_path__ + "static/media/delete.06b52ea8.svg";